import axiosInstance from './index';

export const markAcknowledgementAsSeen = async (acknowledgementId: string): Promise<void> => {
  // TODO: change to rtk
  await axiosInstance.patch(`/v1/acknowledgements/${acknowledgementId}/seen`);
};
